import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../components/layouts/mainLayout";
import RegistrationCard from "../../components/molecules/registrationCard/registrationCard";
import { AppContext } from "../../context/AppContext";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  getPrice,
  getUserData,
  uploadInvoice,
} from "../../firebase/firebaseutils";
import Invoice from "../../components/molecules/invoice";
import { Button } from "@mui/material";
import Loader from "../../components/atoms/loader";
import DoneIcon from "@mui/icons-material/Done";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Alert from "../../components/atoms/alert";
import AdminDashboard from "../../components/molecules/adminDashboard";

const registrationCardData = [
  {
    title: "Individual Delegate",
    registrationFee: "PKR 4000",
    details: "Register as a Single Delegate",
    buttonUrl: "/dashboard/individual_delegation/",
  },
  {
    title: "Delegation",
    registrationFee: "PKR 3500",
    details: "Register as a Delegation of minimum 2 and maximum 10 delegates.",
    buttonUrl: "/dashboard/delegation/",
  },
];

const Dashboard = () => {
  const res = useContext(AppContext);
  const navigate = useNavigate();
  const [registrationType, setRegistrationType] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState(0);
  const [rate, setRate] = useState("");
  const [total, setTotal] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [accomodation, setAccomodation] = useState(0);
  const [accomodationFee, setAccomodationFee] = useState(0);
  const [role, setRole] = useState(false);

  const [description, setDescription] = useState("");
  const [invoiceUploaded, setInvoiceUpload] = useState(false);
  const [invoiceUploadedError, setInvoiceUploadedError] = useState(false);

  const [status, setStatus] = useState(false);

  let md = useMediaQuery("(max-width:800px)");

  const user = res?.appLoadingStates?.user;
  const setLoading = res?.appLoadingStates?.setappLoader;
  const loading = res?.appLoadingStates?.appLoader;
  const [image, setImage] = useState("");

  const handleImageChange = (event) => {
    let file = event.target.files[0];
    setImage(file);
  };

  const submitHandler = async (event) => {
    if (image) {
      setLoading(true);
      const res = await uploadInvoice(image, user?.uid);
      setLoading(false);
      if (res) {
        setInvoiceUpload(true);
        setStatus("pending");
        setInvoiceUploadedError(false);
      } else {
        setInvoiceUpload(false);
        setInvoiceUploadedError(true);
      }
    }
  };

  function truncateString(str, num) {
    // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (str.length <= num) {
      return str;
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + "...";
  }

  useEffect(() => {
    if (!user && res.appLoadingStates?.userStateFetched) navigate("/");

    mainFn();
  }, [registrationType, user]);

  const mainFn = async () => {
    let response = "";
    const getUserInitialInfo = async () => {
      setLoading(true);
      response = await getUserData(user.uid);
      if (response.error) {
        setLoading(false);
      } else {
        setRegistrationType(response?.registeredInEvent);
        setName(response?.firstName + " " + response?.lastName);
        setEmail(response?.email);
        setContact(response?.contact);
        setStatus(response?.status);
        setDescription(`Member Fee`);
        setRole(response?.role);
        if (response?.registeredInEvent === "individual") {
          //check for individual -> quantity = 1
          setQuantity(1);
          if (response?.accommodation === "Yes") {
            setAccomodation(1);
          } else {
            setAccomodation("");
            setAccomodationFee(0);
          }
        }

        if (response?.registeredInEvent === "team") {
          setQuantity(response.teams.length);
          let count = 0;
          for (let element of response.teams) {
            if (element.accommodation == "Yes") {
              count++;
            }
          }
          setAccomodation(count);
        }
        setLoading(false);
      }
    };

    if (user) {
      await getUserInitialInfo();
      getPrice().then((value) => {
        if (value && registrationType === "individual") {
          setRate(value?.individualDelegate);
          if (accomodation === 1) {
            setAccomodation(1);
            setAccomodationFee(value?.accommodationFee);
          }
          const total =
            quantity * value.individualDelegate +
            (response?.accommodation === "Yes" ? value?.accommodationFee : 0);
          setTotal(total);
        } else if (value && registrationType === "team") {
          setRate(value?.delegateFee);
          setAccomodationFee(value?.accommodationFee);
          const total =
            response.teams?.length * value.delegateFee +
            response.teams.filter((team) => team.accommodation == "Yes")
              ?.length *
              value?.accommodationFee;

          setTotal(total);
        }
      });
    }
  };

  if (loading) <Loader />;

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          minHeight: "100vh",
          width: "100vw",
          position: "relative",
          maxWidth: "1400px",
        }}
      >
        <MainLayout componentFlag="dashboard">
          {role === "admin" ? (
            <AdminDashboard />
          ) : registrationType ? (
            <div
              style={{
                display: "flex",
                flexFlow: md ? "column" : "row",
                justifyContent: md ? "center" : "space-between",
                alignItems: md ? "center" : "space-between",

                padding: "20px",
                width: "850px",
              }}
            >
              <Invoice
                name={name}
                contact={contact}
                email={email}
                rate={rate}
                total={total}
                quantity={quantity}
                description={description}
                accomodation={accomodation}
                accomodationFee={accomodationFee}
              />
              {status === "form-submitted" ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexFlow: "column",
                  }}
                >
                  <div
                    style={{
                      // borderRadius: "12px",
                      padding: 20,
                      // background: "red",
                      // background: "#FBFAFA",
                      boxShadow: "0px 8px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "10px",
                      marginTop: md ? "20px" : "0px",
                    }}
                  >
                    <h1
                      style={{
                        margin: 0,
                        padding: 0,
                        marginBottom: 15,
                        color: "#1c1c1c",
                      }}
                    >
                      Proof Of Payment
                    </h1>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexFlow: "column",
                      }}
                    >
                      <Button
                        variant="contained"
                        component="label"
                        endIcon={image ? <DoneIcon /> : ""}
                        sx={{
                          fontWeight: 600,
                          "&:hover": {},
                        }}
                      >
                        {!image ? "Upload" : "Uploaded"}
                        <input
                          hidden
                          accept="file"
                          type="file"
                          onChange={handleImageChange}
                        />
                      </Button>
                      <p style={{ color: "#525257" }}>PNG, JPG or PDF</p>
                    </div>
                    <div
                      style={{
                        alignItems: "center",
                        display: image ? "flex" : "none",
                      }}
                    >
                      <UploadFileIcon
                        sx={{
                          color: "#1976d2",
                          background: "rgba(25,118,210,0.12)",
                          borderRadius: "50px",
                          padding: "8px",
                        }}
                      />
                      <p style={{ marginLeft: 10 }}>
                        {truncateString(image?.name || "", 8)}
                        {/* {} */}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        sx={{ fontWeight: 600, marginTop: "10px" }}
                        onClick={submitHandler}
                      >
                        SUBMIT
                      </Button>
                    </div>
                    <div>
                      {invoiceUploaded ? (
                        <Alert message="successful" severity="success" />
                      ) : (
                        ""
                      )}
                      {invoiceUploadedError ? (
                        <Alert message="error occured" severity="error" />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {status === "rejected" ? (
                    <Alert
                      message="Your registeration is rejected."
                      severity="error"
                      style={{ marginTop: "30px" }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              ) : status === "pending" ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <h1
                    style={{
                      color: "#ED6C02",
                      border: "1px dashed rgba(0, 0, 0, 100)",
                      borderColor: "#525257",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      borderRadius: "12px",
                      width: "300px",
                      marginLeft: md ? "0px " : "80px",
                      // background: "green",
                    }}
                  >
                    Your registeration is under review
                  </h1>
                </div>
              ) : status === "approved" ? (
                <div
                  style={{
                    // background: "red",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <h1
                    style={{
                      color: "green",
                      border: "1px dashed rgba(0, 0, 0, 100)",
                      borderColor: "#525257",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      borderRadius: "12px",
                      width: "300px",
                      marginLeft: "80px",
                      // background: "green",
                    }}
                  >
                    Your registeration is approved.
                  </h1>
                </div>
              ) : status === "rejected" ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexFlow: "column",
                  }}
                >
                  <div
                    style={{
                      // borderRadius: "12px",
                      padding: 20,
                      // background: "#FBFAFA",
                      boxShadow: "0px 8px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "10px",
                      marginTop: md ? "20px" : "0px",
                    }}
                  >
                    <h1
                      style={{
                        margin: 0,
                        padding: 0,
                        marginBottom: 15,
                        color: "#1c1c1c",
                      }}
                    >
                      Proof Of Payment
                    </h1>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexFlow: "column",
                      }}
                    >
                      <Button
                        variant="contained"
                        component="label"
                        endIcon={image ? <DoneIcon /> : ""}
                        sx={{
                          fontWeight: 600,
                          "&:hover": {},
                        }}
                      >
                        {!image ? "Upload" : "Uploaded"}
                        <input
                          hidden
                          accept="file"
                          type="file"
                          onChange={handleImageChange}
                        />
                      </Button>
                      <p style={{ color: "#525257" }}>PNG, JPG or PDF</p>
                    </div>
                    <div
                      style={{
                        alignItems: "center",
                        display: image ? "flex" : "none",
                      }}
                    >
                      <UploadFileIcon
                        sx={{
                          color: "#1976d2",
                          background: "rgba(25,118,210,0.12)",
                          borderRadius: "50px",
                          padding: "8px",
                        }}
                      />
                      <p style={{ marginLeft: 10 }}>
                        {/* {truncateString(, 8)} */}
                        {image?.name}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        sx={{ fontWeight: 600, marginTop: "10px" }}
                        onClick={submitHandler}
                      >
                        SUBMIT
                      </Button>
                    </div>
                    <div>
                      {invoiceUploaded ? (
                        <Alert message="successful" severity="success" />
                      ) : (
                        ""
                      )}
                      {invoiceUploadedError ? (
                        <Alert message="error occured" severity="error" />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {status === "rejected" ? (
                    <Alert
                      message="Your registeration is rejected."
                      severity="error"
                      style={{ marginTop: "30px" }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      // borderRadius: "12px",
                      padding: 20,
                      // background: "red",
                      background: "#FBFAFA",
                      boxShadow: "0px 8px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "10px",
                    }}
                  >
                    <h1
                      style={{
                        margin: 0,
                        padding: 0,
                        marginBottom: 15,
                        color: "#1c1c1c",
                      }}
                    >
                      Proof Of Payment
                    </h1>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexFlow: "column",
                      }}
                    >
                      <Button
                        variant="contained"
                        component="label"
                        endIcon={image ? <DoneIcon /> : ""}
                        sx={{
                          fontWeight: 600,
                          "&:hover": {},
                        }}
                      >
                        {!image ? "Upload" : "Uploaded"}
                        <input
                          hidden
                          accept="file"
                          type="file"
                          onChange={handleImageChange}
                        />
                      </Button>
                      <p style={{ color: "#525257" }}>PNG, JPG or PDF</p>
                    </div>
                    <div
                      style={{
                        alignItems: "center",
                        display: image ? "flex" : "none",
                      }}
                    >
                      <UploadFileIcon
                        sx={{
                          color: "#1976d2",
                          background: "rgba(25,118,210,0.12)",
                          borderRadius: "50px",
                          padding: "8px",
                        }}
                      />
                      <p style={{ marginLeft: 10 }}>{image?.name}</p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        sx={{ fontWeight: 600, marginTop: "10px" }}
                        onClick={submitHandler}
                      >
                        SUBMIT
                      </Button>
                    </div>
                    <div>
                      {invoiceUploaded ? (
                        <Alert message="successful" severity="success" />
                      ) : (
                        ""
                      )}
                      {invoiceUploadedError ? (
                        <Alert message="error occured" severity="error" />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div
              style={{
                background: "#FFFFFF",
                width: "100%",
                height: "100%",
                minHeight: "77vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexFlow: "column",
              }}
            >
              <div>
                <h1 style={{ fontSize: md ? "25px" : "32px" }}>
                  Choose your registration type.
                </h1>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexFlow: md ? "column" : "row",
                  padding: "10px",
                }}
              >
                {registrationCardData.map((cardData, index) => (
                  <RegistrationCard
                    key={index}
                    title={cardData.title}
                    registrationFee={cardData.registrationFee}
                    details={cardData.details}
                    buttonUrl={cardData.buttonUrl}
                  />
                ))}
              </div>
            </div>
          )}
        </MainLayout>
      </div>
    </div>
  );
};

export default Dashboard;
